import { gql } from '@apollo/client';

export const EquipmentFacetFragment = gql`
  fragment EquipmentFacetFragment on Facets {
    equipment {
      security {
        displayName
        name
      }
      comfort {
        displayName
        name
      }
      aircon {
        name
        displayName
      }
      entertainment {
        displayName
        name
      }
    }
  }
`;
